import SiteHardPassword from 'Components/Guards/SiteHardPassword';

export default {
    'site-hard-password': SiteHardPassword
};